import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SyncLoader } from 'react-spinners';
import { resetAuth } from 'library/auth';
import { BRAND_LOADER_COLOR, PORTAL_ROUTES } from 'utils/constants';

export function SignOut() {
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      resetAuth();
      navigate(PORTAL_ROUTES.ROOT, { replace: true });
    }, 1500);

    return () => window.clearTimeout(timeout);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <SyncLoader size={10} color={BRAND_LOADER_COLOR} />
    </div>
  );
}
